import React, { useEffect, useState } from 'react';
import ComponentErrorPage from '../componentErrorPage.js';
import { errorImage } from '../../../content/error-image.js';

/**
 * @typedef {import('../../../App.d.ts').ComponentServiceIncludeIdle} ComponentServiceIncludeIdle
 */
/**
 * @param {ComponentServiceIncludeIdle} props
 */
const ComponentServiceIncludeIdle = ({
  atobPolyfill,
  edgeContent,
  i18n,
}) => {
  const [url, setUrl] = useState('/');

  useEffect(() => {
    setUrl(location.href);
  }, []);

  return (
    <div data-testid="service-include-idle">
      <div className="dodo-service-include__loading">
        <div
          className="ebds-a-activity-indicator ebds-a-activity-indicator--medium"
          role="alert"
        />
      </div>
      <div className="dodo-service-include__error">
        <div className="ebds-container">
          <div className="ebds-content">
            <ComponentErrorPage
              headline={i18n.t('dodo.errors.idle.headline')}
              info={i18n.t('dodo.errors.idle.line1')}
              actionText={i18n.t('dodo.errors.idle.action')}
              actionUrl={url}
              imageUrl={errorImage}
            />
          </div>
        </div>
      </div>
      <div
        dangerouslySetInnerHTML={{ __html: atobPolyfill(edgeContent) }}
        suppressHydrationWarning
        className="dodo-service-include__root"
      />
    </div>
  );
};

export { ComponentServiceIncludeIdle };
export default ComponentServiceIncludeIdle;
